module.exports = __webpack_public_path__ + "assets/img/star_sentence10.3a029a31.png";